module.exports = __webpack_public_path__ + "img/title.5ef8025c.png";